import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

const ProductTilePricing = ({ regularPrice, salePrice, isSalePrice }) =>
    <div className="product-prices">
        { isSalePrice ? (
            <div>
                <span className="sr-only">{translateResourceString("/SearchApp/ProductTilePricing/CurrentPrice")} </span>
                <span className="price-current">{salePrice}</span>
                <span className="sr-only">{translateResourceString("/SearchApp/ProductTilePricing/ListPrice")} </span>
                <span className="price-old">{regularPrice}</span>
            </div>
        ) : (
            <div>
                <span className="sr-only">{translateResourceString("/SearchApp/ProductTilePricing/CurrentPrice")} </span>
                <span className="price-current">{regularPrice}</span>
            </div>
        )}
    </div>;

ProductTilePricing.propTypes = {
    regularPrice: PropTypes.string,
    salePrice: PropTypes.string,
    isSalePrice: PropTypes.bool
};

export default ProductTilePricing;